/* istanbul ignore file */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { RaaRoles } from '../../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../../highorder/HasRolePrivileges';

function EmptyNotificationTemplateMessage() {
  const history = useHistory();
  return (
    <div className="card">
      <div className="card-body text-left">
        {/* <h4>Managing alert notifications is simple. Here&#39;s what you need to know:</h4> */}
        <ul>
          <li>
            Customize the messages that get emailed and texted to your team during alert events.
          </li>
          <li>
            Include optional keywords in both “Triggered” and “All Clear” templates.
          </li>
          <li>
            1 template can be associated with multiple alerts (and vice-versa).
          </li>
          <li>
            Learn more:
            {' '}
            <a target="_blank" rel="noopener noreferrer" href="https://avtech.com/articles/11438/">How To Create Notification Templates In Room Alert Account</a>
            .
          </li>
        </ul>
        <div className="my-3 row">
          <div className="col">
            <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/s/actions/notification-templates/new')}
              >
                Create Template
              </button>
            </HasRolePrivileges>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyNotificationTemplateMessage;
